<template>
  <div class="ocx-window-wrap" id="ocx-window-wrap">
    <div
      class="ocx-box"
      v-loading="lodingzp"
      element-loading-text="视频抓拍中..."
      element-loading-spinner="el-icon-loading"
    >
      <VideojsPlayerNew
        ref="player"
        @playing="playing"
        @onFocus="onFocus"
        @playBackOk="playBackOk"
        @playVideoClose="playVideoClose"
        @handlePlayStatus="handlePlayStatus"
        @timeupdate="timeupdate"
        @playReady="playReady"
        @playSuccess="playSuccess"
        @handleClickWnd="handleClickWnd"
        @dropCall="dropCall"
        @closeOtherTip="closeOtherTip"
        :windowNumber="windowNumber"
        :playOption="playOption"
      ></VideojsPlayerNew>
    </div>
    <div class="control-wrap">
      <div class="left flex-row">
        <el-button
          class="iconfont-lunan icon-lunan-qidong"
          type="text"
          size="medium"
          :title="$t('video.title.play')"
          @click="handleSwitchStatus(true)"
          onselectstart="return false;"
        ></el-button>
        <el-button
          class="icon iconfont-lunan icon-lunan-zanting"
          type="text"
          title="暂停"
          @click="handleSwitchStatus(false)"
        >
        </el-button>

        <el-button
          class="icon iconfont-add iconshangyishou_huaban"
          type="text"
          title="上一个"
          @click="handleBeforeOrNext('before')"
        >
        </el-button
        ><el-button
          class="icon iconfont-add iconxiayishou_huaban"
          type="text"
          title="下一个"
          @click="handleBeforeOrNext('next')"
        >
        </el-button>

        <el-button
          class="iconfont-lunan icon-lunan-tingzhi"
          type="text"
          size="medium"
          :title="$t('video.title.stop')"
          @click.stop="stopAll"
          onselectstart="return false;"
        ></el-button>
        <!--轮训列表-->
        <!-- <el-button
          class="iconfont-lunan icon-lunan-zanting"
          type="text"
          size="medium"
          :title="$t('video.title.stopPlay')"
          :disabled="activeWindow > -1"
          v-show="isPlay && !tourDisplay"
          @click.stop="pause"
          onselectstart="return false;"
        ></el-button> -->
        <!-- <span v-show="!tourDisplay" class="ml10">
          <span>{{ playTime }}</span
          ><span class="split-span">/</span><span>{{ endTime }}</span>
        </span> -->
        <!-- <div class="ml30">
          <el-button
            class="iconfont-lunan icon-lunan-qiehuan"
            :title="isLoop ? '显示摄像机列表' : '显示轮巡列表'"
            type="text"
            size="medium"
            @click="switchList"
          ></el-button>
          <span class="ml10 pointer mr10" @click="setConfig"
            >点击设置轮巡参数</span
          >
          <el-button
            class="iconfont-lunan icon-lunan-qidong"
            type="text"
            size="medium"
            :disabled="!tourDisplay"
            @click="playTour"
          ></el-button>
        </div> -->
      </div>
      <div class="right">
        <!-- <span class="iconfont"
              :class="{'disabled': !playerActive()}"
              v-if="showSnapList"
              :title="$t('video.title.snapList')"
              @click.stop="handleVideo('localSnapList')"
              onselectstart="return false;">&#xe64a;</span>
        <span class="iconfont"
              :class="{'disabled': !playerActive()}"
              v-else
              :title="$t('video.title.localSnap')"
              @click.stop="handleVideo('localSnapshotToDir')"
              onselectstart="return false;">&#xe64a;</span> -->
        <!-- <span class="iconfont" :title="$t('video.title.platSnap')" @click.stop="handleVideo('platformSnapshot')" onselectstart="return false;">&#xe64b;</span> -->
        <el-button
          type="text"
          class="iconfont"
          :title="$t('video.title.fourScreen')"
          v-show="screenSetShow"
          @click.stop="showScreenSet(4)"
        >
          &#xe645;&#xe623;
          <div v-show="screenSet" class="screen-set content-bg-color">
            <span
              class="iconfont-item icon iconfont-add iconwindow_1"
              :title="$t('video.title.oneScreen')"
              @click.stop="changeWindowNumber(1)"
            ></span>
            <span
              class="iconfont-item icon iconfont-add iconwindow_4"
              :title="$t('video.title.fourScreen')"
              @click.stop="changeWindowNumber(4)"
            ></span>
            <span
              class="iconfont-item icon iconfont-add iconwindow_9"
              :title="$t('video.title.nineScreen')"
              @click.stop="changeWindowNumber(9)"
            ></span>
            <span
              class="iconfont-item icon iconfont-add iconwindow_16"
              title="十六分屏"
              @click.stop="changeWindowNumber(16)"
            ></span>
            <!-- <span
              class="iconfont-item padding10"
              :title="$t('video.title.nineScreen')"
              @click.stop="changeWindowNumber(9)"
              >&#xe70e;</span
            > -->
          </div>
        </el-button>
        <el-button
          type="text"
          class="iconfont"
          :title="$t('video.title.fullScreen')"
          @click.stop="handleVideo('fullScreen')"
          onselectstart="return false;"
          >&#xe6a2;</el-button
        >
        <el-button
          type="text"
          class="iconfont"
          v-if="showResult"
          @click.stop="handleShowVideos()"
          onselectstart="return false;"
          ><i :class="[$config.fontFamily, 'ioc-Drop_down']"></i
        ></el-button>
      </div>
    </div>
  </div>
</template>

<script>
import controlBarMixin from "../../script/controlMixin";
import VideojsPlayerNew from "@src/components/common/media-player/video-player.vue";
// import VideojsPlayerNew from '@src/components/common/media-player/player-box.vue'
import { api } from "../../api.js";
import DayJs from "dayjs";
import busVue from "@/common/utils/busVue";
import eventBus from "@src/common/utils/eventBus";
import axios from "axios";
import reserveSetVue from "../../../reserve/view/reserveSet.vue";
export default {
  name: "MediaPlayer",
  components: {
    VideojsPlayerNew,
  },
  mixins: [controlBarMixin],
  props: {
    playDeviceData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showResult: {
      type: Boolean,
      default: true,
    },
    showSnapList: {
      type: Boolean,
      default: false,
    },
    screenSetShow: {
      type: Boolean,
      default: true,
    },
    tourDisplay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 当前录像窗口ID
      videoWindowId: "",
      // 当前正在录像窗口编号
      videoWindow: "",
      // windowVideoArr: [],
      // windowVideoArr: this.$refs.player.windowVideoArr,
      currentIndex: null,
      cameraCode: "",
      playType: "",
      backStartTime: "",
      activeWindow: -1,
      backEndTime: "",
      cameraName: "",
      playOption: {
        // videoSrc: 'http://nebula-playback.qiniudn.com/test-playback/flv/sample.flv',
        // videoSrc: 'http://127.0.0.1:9003/09d0359b1dd329dc7b0e13b30868d975.mp4',
        videoSrc: "",
        deviceId: "1",
        cameraType: "",
        posterSrc: "/images/theme/newDark/default.png",
      },
      playList: [],
      screenSet: false,
      form: {
        cameraCode: "",
        recordMethod: "0",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        cameraName: "",
        speedNum: 1,
      },
      code: {
        wnd: "",
        showCameraCode: "",
        showCameraName: "",
        NVRcode: "",
        vFromTime: "",
        VToTime: "",
      },
      keyMap: {
        2: "up_shift",
        4: "left_shift",
        3: "down_shift",
        7: "right_shift",
        21: "aperture_open", //光圈扩大
        22: "aperture_close", //光圈缩小
        25: "focal_near", //聚焦近
        26: "focal_far", //聚焦远
      },
      isPlay: false,
      data: null,
      playTime: "-",
      endTime: "-",
      playerIndex: -1,
      playCatch: false,
      // 窗格数，默认四个
      windowNumber: 4,
      cloudLoading: false,
      isLoop: false,
      lodingzp: false,
    };
  },
  computed: {
    localOffset() {
      let date = new Date();
      return date.getTimezoneOffset() * 60000;
    },
    windowVideoArr() {
      //  let arr = [];
      this.$nextTick(() => {
        console.log(
          this.$refs.player.windowVideoArr,
          "this.$refs.player.windowVideoArr"
        );
        // arr = this.$refs.player.windowVideoArr;
      });
      // console.log(this.$refs.player, "this.$refs.player.windowVideoArr");
      return [];
      // return arr;
    },
  },
  watch: {
    windowVideoArr(newVal) {
      console.log(newVal, "----newav");
    },
  },
  mounted() {},
  created() {
    eventBus.addListener("handleBack", (info) => {
      this.handlePlayBackVideo(info);
    });
  },
  methods: {
    handleClickWnd(wnd) {
      this.activeWindow = wnd;

      console.log(wnd, "222222");
    },
    playBackOk(data) {
      console.log("window--palybac");
      this.$emit("playBackOk", data);
    },
    playVideoClose(index) {
      // 关闭的摄像机回调
      // let bfVideo = [...this.$refs.player.deviceList]
      // let bf2 = []
      // bfVideo.forEach((el, index2) => {
      //   if (el.id) {
      //     bf2.push(el)
      //   }
      // })
      let bf2 = [...this.$refs.player.showIconVideo()];
      this.$nextTick(() => {
        this.$emit("playVideoOK", bf2);
      });
    },
    dropCall(option) {
      console.log(option, "====dropcallindex");
      this.handlePlay(option.option, option.index);
    },
    cloudBack() {
      this.cloudLoading = false;
    },
    getDeviceName(thirdDeviceId) {
      let deviceIndex = this.playDeviceData.findIndex(
        (item) => item.thirdDeviceId == thirdDeviceId
      );
      if (deviceIndex > -1) {
        return this.playDeviceData[deviceIndex].name;
      } else {
        return "";
      }
    },
    // 本地抓拍回调
    getPhotoCatchTips(isFinish) {
      this.$refs.OcxCom.ocxComObject.closeCatchTips(isFinish);
    },
    // 停止所有窗口
    stopAll() {
      // this.handleVideo('stopLivePlay');
      this.isPlay = false;
      this.playTime = "-";
      this.endTime = "-";
      this.playList = [];
      this.$refs.player.closeAllVideo();
      this.$emit("playVideoOK", []);
      this.$emit("stopAll");
    },
    // 修改窗格数
    changeWindowNumber(number) {
      this.windowNumber = number;
      this.$emit("changeWindowNumber", number);
    },
    //视频操作
    handleVideo(type, changeWindowNum) {
      // let selectWindow = this.$refs.OcxCom.ocxComObject.ocxObject.IVS_OCX_GetSelectWnd();
      // console.log(1212)let cametaCode=this.$refs.OcxCom.ocxComObject.ocxObject.IVS_OCX_GetCameraByWnd(selectWindow);
      // // 当前没有视频播放 且不为切换窗格数
      // if(cametaCode == 1 && !changeWindowNum && type != 'stopLivePlay'){
      //   return;
      // }
      this.controlHandle(type);
    },
    requestFullscreen() {
      console.log("全屏");
      const el = document.getElementById("content-right");
      const isFull =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      if (isFull) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        (el.requestFullscreen && el.requestFullscreen()) ||
          (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
          (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
          (el.msRequestFullscreen && el.msRequestFullscreen());
      }
    },
    // 本地抓拍
    localSnap() {
      if (this.playList.length === 0) {
        this.$message.warning("请选择摄像机");
        return;
      }
      this.lodingzp = true;
      const param = {
        deviceId: this.playList[this.$refs.player.playerIndex].deviceId,
      };
      this.$fetch(api.localSnap, param).then((res) => {
        if (res.success) {
          this.saveImage(res.returnObj.img_url);
          this.$emit("localSnap", res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
        setTimeout(() => {
          this.lodingzp = false;
        }, 300);
      });
      // const url = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1587485216543&di=595663263fb86b900008f16b9127936a&imgtype=0&src=http%3A%2F%2Fpic.90sjimg.com%2Fback_pic%2Fqk%2Fback_origin_pic%2F00%2F01%2F90%2F7b96b74a0a2b615089859de45551ecc0.jpg';
      // this.saveImage(url)
    },
    localSnapList() {
      if (this.playList.length === 0) {
        this.$message.warning("请选择摄像机");
        return;
      }
      const param = {
        deviceId: this.playList.map((item) => item.deviceId),
      };
      this.$fetch(api.localSnapList, param).then((res) => {
        if (res.success) {
          res.returnObj.forEach((img) => {
            this.saveImage(img.img_url);
          });
          this.$emit("localSnapList", res.returnObj);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    closeOtherTip() {
      this.screenSet = false;
    },
    showScreenSet() {
      this.screenSet = !this.screenSet;
    },
    saveImage(url) {
      this.downloadIamge(url);
    },
    downloadIamge(imgsrc) {
      //下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "snap_" + new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    // 是否是球机
    isBallCamera() {
      // let selectWindow = this.$refs.OcxCom.ocxComObject.ocxObject.IVS_OCX_GetSelectWnd();
      let cametaCode = "1";
      let cameraType = "";
      if (
        this.playList.length &&
        this.playList[this.$refs.player.playerIndex]
      ) {
        cametaCode = this.playList[this.$refs.player.playerIndex].deviceId;
        cameraType = this.playList[this.$refs.player.playerIndex].cameraType;
      }
      let isBall = false;
      if (cametaCode === "1") {
        isBall = -1;
      }
      if (parseInt(cameraType) === 2 || parseInt(cameraType) === 1) {
        isBall = true;
      }
      return isBall;
    },
    playerActive() {
      return (
        this.playList.length && this.playList[this.$refs.player.playerIndex]
      );
    },
    pauseActive() {
      return (
        this.playList.length &&
        this.playList[this.$refs.player.playerIndex] &&
        this.playList[this.$refs.player.playerIndex].playType === "playback"
      );
    },
    handleCloudControl(option) {
      this.handleCloudControlStart(option);
      // this.cloudControlStart = setTimeout(() => {
      //   this.handleCloudControl(option);
      //   this.handleCloudControlStart(option);
      // }, 300);
    },
    // 云台控制 方向，聚焦
    handleCloudControlStart(option) {
      console.log("option", option, this.$refs.player);
      let key = `wnd_${this.$refs.player.activeWnd}`;
      // console.log(this.$refs.player.playRecord)
      this.$log.debug("handleCloudControlStart===========>", option);
      // let isBall = this.isBallCamera();
      // if (this.$refs.player.playerIndex === -1) {
      //暂时注释 9-26
      // if (!this.$refs.player.playRecord || !this.$refs.player.playRecord[key]) {
      //   this.$message({
      //     message: "暂无播放视频，请选择视频",
      //     type: "warning",
      //   });
      //   return;
      // }
      console.log(option.ptzCode, "option.ptzCode");
      //云台控制接口
      let params = {
        PTZCmdID: option.optCode,
        PTZCmdPara1: option.speed,
        PTZCmdPara2: option.speed,
        PTZCmdPara3: option.speed,
      };
      console.log(params, "====paramscontrol");
      this.$fetch(api.ptcControl + "/" + option["cameraId"], params).then(
        (res) => {
          if (res.ErrCode === 0) {
            setTimeout(() => {
              this.$fetch(api.ptcControl + "/" + option["cameraId"], {
                PTZCmdID: 0x0901,
                PTZCmdPara1: option.speed,
                PTZCmdPara2: option.speed,
                PTZCmdPara3: option.speed,
              });
            }, 3000);
          }
        }
      );
      // axios({
      //   method: "POST",
      //   url: "http://192.169.15.33:7010/VIID/ptz/ctrl",
      //   headers: {
      //     "Content-Type": "application/json; charset=utf8",
      //   },
      //   responseType: "json",
      // }).then((res) => {});
      // else if (isBall === -1) {
      //   this.$message({
      //     message: this.$t('video.message.noVideo'),
      //     type: 'warning'
      //   });
      //   return;
      // }
      // else if (this.pauseActive()) {
      //   this.$message({
      //     message: this.$t('video.message.canOperate'),
      //     type: 'warning'
      //   });
      //   return;
      // }
      // this.$fetch(api.ptcControl, {
      //   deviceId: this.playList[this.$refs.player.activeWnd].deviceId,
      //   action: this.keyMap[option.optCode],
      //   speed: option.speed,
      // }).then((resp) => {
      //   if (!resp.success) {
      //     this.$message.error(resp.msgContent);
      //   }
      // });
    },
    handlePlayStatus(status) {
      this.$log.debug("handlePlayStatus===========>");
      this.isPlay = status;
    },
    handleCloudControlStop(cameraCode) {
      this.$log.debug("handleCloudControlStop===========>");
      this.$fetch(api.ptcRelese + "/" + cameraCode).then((res) => {});
      clearTimeout(this.cloudControlStart);
    },
    setForm(item) {
      this.form.cameraName = item.name;
      this.form.cameraCode = item.thirdCameraId;
    },
    //启动
    resume() {
      if (!this.pauseActive()) {
        return;
      }
      this.$refs.player.resume();
    },
    pause() {
      if (!this.pauseActive()) {
        return;
      }
      this.$refs.player.pause();
    },
    onFocus(index) {
      this.playerIndex = index;
    },
    playReady(index) {
      // console.log(this.$refs.player.deviceList)
      this.playList[index] = Object.assign({}, this.playOption);
      this.$log.debug("this.playList:", this.playList);
      this.playVideoClose();
    },
    playSuccess(frameId, item) {
      console.log("窗口播放成功", item);

      return item;
    },
    playing(event, index) {
      // this.$log.debug('playing==>', event);
      if (this.$refs.player.playerIndex > -1) {
        if (this.$refs.player.playerIndex === parseInt(index)) {
          this.isPlay = true;
        }
      } else {
        this.isPlay = false;
      }
    },
    timeupdate(curTime, index) {
      if (this.$refs.player.playerIndex > -1) {
        if (this.$refs.player.playerIndex === parseInt(index)) {
          if (
            this.playList[this.$refs.player.playerIndex].playType === "playback"
          ) {
            // const startTime = Math.ceil(curTime) * 1000 + this.playList[this.$refs.player.playerIndex].startTime
            const endTime =
              this.playList[this.$refs.player.playerIndex].endTime;
            const startTime =
              Math.ceil(curTime) * 1000 +
              this.playList[this.$refs.player.playerIndex].startTime;
            // const endTime = this.playList[this.$refs.player.playerIndex].endTime + Math.abs(this.localOffset)
            this.$log.debug("startTime:", Math.ceil(startTime));
            this.$log.debug("endTime:", Math.ceil(endTime));
            this.playTime = DayJs(Math.ceil(startTime)).format("HH:mm:ss");
            this.endTime = DayJs(Math.ceil(endTime)).format("HH:mm:ss");
            // this.$log.debug('playTime:', this.playTime);
            // this.$log.debug('endTime:', this.endTime);
            this.$emit("timeUpdate", startTime);
          } else {
            this.playTime = "-";
            this.endTime = "-";
          }
          this.isPlay = true;
        }
      }
    },
    //播放视频流
    handlePlay(item, index) {
      console.log("itm=----双击播放视频流", item, index);
      // 先判断是否全屏
      let obj = this.$refs.player.fourFullScreen;
      let objList = this.$refs.player.playerList;
      for (let key in obj) {
        if (obj[key] == true && objList.length != 1) {
          this.$message({
            showClose: true,
            //       message: '当前全屏状态下,不能切换视频，请双击屏幕退出全屏',
            message: "当前放大状态下,不能切换视频，请退出放大模式",
            type: "warning",
          });
          return false;
        }
      }
      this.playOption.deviceId = item.thirdCameraId;
      this.playOption.cameraType = item.cameraType;
      this.playOption.playType = "live";
      this.$refs.player.playLiveVideo(item, index);
    },
    //单个点击播放
    // handlePlayBackSingleVideo(option) {
    //   console.log("dange1");
    //   let params = {
    //     startTime: option.startTime,
    //     endTime: option.endTime,
    //     deviceObj: option.deviceObj,
    //   };
    //   this.$nextTick(() => {
    //     console.log("单个拆查询");
    //     this.$refs.player.playBackVideo(params);
    //   });
    // },
    //录像回放--根据选中相机循环查询回放
    handlePlayBackVideo(option) {
      console.log(option, "====option");
      option.cameraDataList.forEach((item) => {
        let params = {
          startTime: option.startTime,
          endTime: option.endTime,
          deviceObj: item,
        };
        this.$nextTick(() => {
          this.$refs.player.playBackVideo(params);
        });
      });

      // eventBus.$on("handlePlayBackVideo", (data) => {
      //   console.log(data, "====plyblack");
      // });
      // console.log(option, data, "====playbackvidewo");
      // this.$log.debug("handlePlayBackVideo===>", option);
      // this.playOption.deviceId = option.deviceId;
      // this.playOption.startTime = option.startTime;
      // this.playOption.endTime = option.endTime;
      // this.playOption.playType = "playback";
      // this.$refs.player.playBackVideo(option);
    },
    handleTimeNumber(val) {
      let yearStr = val.substring(0, 4);
      let monthStr = val.substring(4, 6);
      let dayStr = val.substring(6, 8);
      let hhStr = val.substring(8, 10);
      let mmStr = val.substring(10, 12);
      let ssStr = val.substring(12, 14);
      let _tmpStr =
        yearStr +
        "/" +
        monthStr +
        "/" +
        dayStr +
        " " +
        hhStr +
        ":" +
        mmStr +
        ":" +
        ssStr;
      return new Date(_tmpStr).getTime() + Math.abs(this.localOffset);
    },
    // 播放时间格式
    formatTime(val) {
      if (val === "" || val === null || val === undefined) {
        return "00:00:00";
      }
      return DayJs(this.handleTimeNumber(val)).format("HH:mm:ss");
    },
    handleShowVideos() {
      this.$emit("handleShowVideos");
    },
    switchList() {
      this.$emit("switchList");
    },
    setConfig() {
      this.$router.push({
        path: "/video/config",
      });
    },
    handleBeforeOrNext(status) {
      status == "before"
        ? (this.$refs.player.activeWnd = this.$refs.player.activeWnd - 1)
        : (this.$refs.player.activeWnd = this.$refs.player.activeWnd + 1);
      console.log(status, "====sstyai");
    },
    handleSwitchStatus(status) {
      let id = "";
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.$refs.player.windowVideoArr.forEach((item, ind) => {
            console.log(item, "=========item");
            if (ind + 1 == this.activeWindow) {
              id = item.iframeID;
              console.log(id, "===id");
              resolve(id);
            }
          });
        });
      }).then((res) => {
        console.log(res, "====rez");
        imosSdk.switchPlayStatus(res, (result) => {
          if (result.ErrCode === 0) {
            console.log("oookswtich");
          } else {
            console.log("error" + result.ErrMsg);
          }
        }),
          status;
      });

      // this.$emit("handleSwitchStatus", status, this.activeWindow);
    },
  },
};
</script>
<style lang="scss" scoped>
.ocx-box {
  height: 580px;
}
.padding10 {
  padding-left: 10px;
}
.ocx-window-wrap {
  background: rgba(11, 18, 35, 1);
  .control-wrap {
    display: flex;
    height: 56px;
    justify-content: space-between;
    margin-top: 8px;
    .right {
      margin: auto 21px auto 0;
      .screen-set {
        z-index: 2;
        position: absolute;
        top: -35px;
        height: 35px;
        left: -10px;
        background: rgba(13, 18, 28, 1) !important;
        border: 1px solid royalblue;
        padding: 0 10px;
        // box-shadow: 1px 1px 1px #888888;
        border-radius: 3px;
      }
      .el-button {
        position: relative;
      }

      button {
        font-size: 26px;
      }
      .iconfont {
        cursor: pointer;

        // font-size: 14px;
        margin-right: 10px;
      }
      .iconfont-item {
        line-height: 35px;
        color: #c0c0c0;
        font-size: 25px;
      }
    }
  }
}
.left button {
  font-size: 26px;
}
</style>

